import { StdResponse, request } from "@/global/config/request";
import { User } from "@/global/interface/project-manage/user";


export function getUsers(params?: {}): Promise<StdResponse<any>> {
    return request.get(`/users`, {
        params: {
            ...params,
        }
    })
}

export function addUser(user: User, params?: {}): Promise<StdResponse<any>> {
    return request.post(`/users`, user, {
        params: {
            ...params,
        }
    })
}


export function findUserDetail(userUuid: string, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/users/${userUuid}`, {
        params: {
            ...params,
        }
    })
}

export function updateUser(userUuid: string, data: User, params?: {}): Promise<StdResponse<any>> {
    return request.put(`/users/${userUuid}`, data, {
        params: {
            ...params,
        }
    })
}

export function getUserByLogin(username: string, password: string, params?: {}): Promise<StdResponse<any>> {
    return request.post(`/users/login`, null, {
        params: {
            ...params,
            username: username,
            password: password,
        }
    })
}

export function getUsersCheckLogin(params?: {}): Promise<StdResponse<any>> {
    return request.get(`/users/check-login`, {
        params: {
            ...params,
        }
    })
}